<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :title="$t('password-luck-history.口令抽奖记录')"
    width="454px"
    class="dialog-dark dialog-include-table"
    custom-class="historyVisible"
    @open="showHistory"
  >
    <div v-for="(item, index) in winnerHisList" :key="index" class="winner-history-box" >
      <p class="title">
        <span>{{ item.title }}/{{ item.subject }}（{{ item.winnersCount }}人）</span>
      </p>

      <el-table :data="item.showWinners" class="table-dark table-noborder">
        <el-table-column prop="nickname" :label="$t('luck-history.姓名')" width="180px">
        </el-table-column>
        <el-table-column prop="winnerCode" :label="$t('luck-history.中奖码')"> </el-table-column>
      </el-table>
      
      <button
        v-if="item.winners.length > 0"
        class="load-more-winners-button"
        @click="clickLoadMoreWinners(index)"
      >{{ $t("passwordLuckDraws.查看更多") }}</button>

      <div class="audience-list-box">
        <div class="head">{{ $t('password-luck-history.参与观众') }}</div>
        <!-- <AudienceScrollLoadList :itemHeight="30" :column="2" :raffleId="item.id" /> -->
        <AudienceClickLoadList :column="2" :pageSize="20" :page1ResultStr="item.page1ResultStr" :raffleId="item.id" />
      </div>
    </div>
    <div v-if="!winnerHisList.length" class="blank-wrapper">
      <Blank :text="$t('luck-history.暂无抽奖记录')" :sub-text="$t('luck-history.仅显示开启直播后的抽奖结果')" />
    </div>
  </el-dialog>
</template>
<script>
import {getWinnerHistory} from "@/api/liveRequest/luckDawApi";
import { Dialog, Table, TableColumn } from "element-ui";
import Blank from "@/components/blank";
// import AudienceScrollLoadList from './audience-scroll-load-list.vue';
import AudienceClickLoadList from './audience-click-load-list.vue';

export default {
  name: "PasswordLuckHistory",
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Blank,
    // AudienceScrollLoadList,
    AudienceClickLoadList
  },
  data() {
    return {
      winnerHisList: []
    };
  },
  methods: {
    // 点击抽奖历史
    async showHistory() {
      const { data: winnerHisList } = await getWinnerHistory({candidatesRange: 7});
      
      for (const item of winnerHisList) {
        item.winnersCount = item.winners.length;
        item.showWinners = item.winners.splice(0, 20);

        if (!item.participants) continue;

        item.page1ResultStr = JSON.stringify({
          pageCount: item.participants.length + (item.moreParticipant ? 1 : 0),
          list: item.participants
        });
      }
      this.winnerHisList = winnerHisList;
    },
    // 抽奖历史弹窗关闭
    handleClose() {
      this.winnerHisList = [];
      this.$emit("update:visible", false);
    },
    clickLoadMoreWinners(index) {
      const item = this.winnerHisList[index];
      if (!item) return;

      item.showWinners.push(...item.winners.splice(0, 20));
    }
  },
};
</script>

<style lang="scss" scoped>
.historyVisible {
  overflow: hidden;
  .el-dialog__body {
    padding: 0px 20px;
    max-height: 315px;
    overflow: auto;
    .title {
      color: #EA494B;
      margin-top: 18px;
      font-size: 16px;
      font-weight: 500;
      line-height: 25px;
      text-align: center;
    }
    .historyItem {
      color: #3b3b3b;
      span {
        display: inline-block;
        width: 50%;
        line-height: 24px;
      }
    }
    .listTitle {
      border-bottom: 1px solid #999;
      margin-top: 10px;
      font-weight: bold;
      padding-bottom: 5px;
    }
  }
}

.winner-history-box {
  margin-top: 30px;

  &:nth-child(1) {
    margin-top: 0px;
  }
}

.audience-list-box {
  .head {
    padding: 5px 0;
    text-align: center;
    color: #acb2bf;
    font-weight: 560;
    font-size: 12px;
    margin-top: 10px;
    @include background-color("tableCellBg");
  }

  ::v-deep .audience-click-load-list {
    margin-top: 12px;

    &.empty-data {
      margin-top: 0px;
    }

    .table .row .column {
      margin: 6px 4px;
      text-align: center;
      color: #acb2bf;
    }
  }
}


.noneList {
  img {
    width: 160px;
    display: block;
    margin: 10px auto 40px;
  }
  p {
    font-size: 14px;
    color: #fff;
    text-align: center;
  }
  p:nth-child(3) {
    margin-top: 12px;
    color: #acb2bf;
    font-size: 12px;
  }
}
.table-dark {
  margin-top: 14px;
}
::v-deep {
  .el-dialog {
    overflow: hidden;
  }
  .el-dialog__body {
    position: relative;
    max-height: 462px;
    min-height: 272px;
    overflow: auto;
  }
  .el-table .el-table__row td.el-table__cell {
    padding: 5px 0;

    div {
      color: #acb2bf !important;
    }
  }
}

.blank-wrapper {
  position: absolute;
  top: -48px;
  bottom: 0;
  width: 100%;
}
.unSend {
  display: inline-block;
  width: 42px;
  height: 20px;
  line-height: 18px;
  border: 1px solid #ACB2BF;
  font-size: 12px;
  color: #ACB2BF;
  text-align: center;
  vertical-align: middle;
  border-radius: 2px;
  box-sizing: border-box;
}

.load-more-winners-button {
  color: #3986EE;
  text-align: center;
  margin: 5px 0;
  border: none;
  background: none;
  text-align: center;
  transform: translateX(-50%);
  left: 50%;
  position: relative;
  cursor: pointer;
}
</style>
